<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="popupTitle" @close="closePopup" width="500px">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h4 tit">
          어플리케이션 URL 목록
        </div>
        <div>
          <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool" />
        </div>
      </el-row>
      <el-table-wrapper ref="applUrlTable" :data="dataList" :columns="columns" :column-default="columnDefault" :total="total" :show-search-tool="showSearchTool"
      pagination :show-custom-header="true" style="width:100%;" @selection-change="onChangeSelectionRow" @condition-change="loadData" />
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="!disabledSaveBtn" @click="saveApplicationUrl">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';

export default {
  name: 'WApplUrlSettingPopup',
  data() {
    return {
      columnDefault,
      popupTitle: '어플리케이션 URL 등록',
      selectedRows: [],
      dataList: [],
      columns: [
        { width: 55, type: 'selection' },
        { prop: 'applicationUrl', remoteProp: 'application_url', label: '어플리케이션 URL', sortable: true, searchable: true },
      ],
      total: 0,
      showSearchTool: false,
    };
  },
  computed: {
    disabledSaveBtn() {
      return this.selectedRows.length > 0;
    },
  },
  methods: {
    closePopup() {
      this.dataList = [];
      this.selectedRows = [];
      this.showSearchTool = false;
      this.$refs.applUrlTable.clearFilter();
      this.$refs.slidingPopup.visible = false;
    },
    open(applicationId) {
      this.$refs.slidingPopup.visible = true;
      this.selectApplicationId = applicationId;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    /**
     * 어플리케이션의 url 정보 및 추가 할 수 있는 url을 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      const tableParams = this.$refs.applUrlTable.getParameter();
      ApmSettingAPI.getUncoupledApplicationUrl({ ...tableParams }).then((response) => {
        if (response.data.success) {
          this.dataList = response.data.data;
          this.total = response.data.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    /**
     * 테이블 selection 이벤트 핸들러
     * @param  {[type]} record [description]
     * @return {[type]}     [description]
     * @author jda
     */
    onChangeSelectionRow(record) {
      this.selectedRows = record;
    },
    /**
     * 어플리케이션 URL 추가/변경한 사항을 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    saveApplicationUrl() {
      const params = {
        applicationId: this.selectApplicationId,
        INSERT: this.selectedRows,
        // DELETE: differesnce(this.dataList, selectedRows),
      };
      const target = '어플리케이션 URL';
      const action = msgUtil.action.SAVE;
      ApmSettingAPI.updateApplUrlList(params).then((response) => {
        if (response.data.success) {
          this.$emit('reloadData');
          this.closePopup();
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/ApplUrlSettingPopup.vue